import floor from 'lodash/floor';
import isEmpty from 'lodash/isEmpty';

const createPromo = ({
	namespace,
	stateNodeName
}) => {
	// actions types
	const TOGGLE_GALLERY = `${namespace}/${stateNodeName}-toggle-gallery`;
	const CHANGE_CATEGORY = `${namespace}/${stateNodeName}-change-category`;
	const SET_ZIP_FILES_SIZE = `${namespace}/${stateNodeName}-set-zip-files-size`;

	// initState
	const initialState = {
		shouldShowGallery: false,
		showedFileIndex: null,
		currentCategory: null,
		zipFilesSize: 0
	};

	// actions
	const actions = {
		promoGalleryToggle: (fileIndex) => ({
			type: TOGGLE_GALLERY,
			payload: fileIndex
		}),

		promoChangeCategory: categoryId => ({
			type: CHANGE_CATEGORY,
			payload: categoryId
		}),

		promoSetZipFilesSize: sizeInBites => ({
			type: SET_ZIP_FILES_SIZE,
			payload: floor(sizeInBites / 1000000, 2)
		})
	};

	// reducers
	const reducers = {
		[TOGGLE_GALLERY]: (state, action) => ({
			...state,
			promo: {
				...state.promo,
				shouldShowGallery: !state.promo.shouldShowGallery,
				showedFileIndex: action.payload
			}
		}),

		[CHANGE_CATEGORY]: (state, action) => ({
			...state,
			promo: {
				...state.promo,
				currentCategory: action.payload
			}
		}),

		[SET_ZIP_FILES_SIZE]: (state, action) => ({
			...state,
			promo: {
				...state.promo,
				zipFilesSize: action.payload
			}
		})
	};

	// selectors
	const selectors = {
		getData: state => ({
			promoForPreview: selectors.getForPreview(state),
			promoFilesList: state[namespace].data && state[namespace].data.promo,
			shouldShowGallery: state[namespace][stateNodeName].shouldShowGallery,
			showedFileIndex: state[namespace][stateNodeName].showedFileIndex,
			categories: selectors.getCategories(state),
			currentCategory: selectors.getCurrentCategory(state),
			zipFilesSize: state[namespace][stateNodeName].zipFilesSize
		}),

		getForPreview: state => {
			if (!state[namespace].data || !state[namespace].data.promo) return {};

			const offerPromo = state[namespace].data.promo;
			const currentCategory = selectors.getCurrentCategory(state);

			const selectedPromo = offerPromo[currentCategory] ? [].concat(offerPromo[currentCategory]) : [];

			return {
				main: selectedPromo.shift(),
				thumbs: selectedPromo.slice(0, 3),
				shouldShowMore: selectedPromo.length - 4 > 0
			};
		},

		getCurrentCategory: state => {
			const { currentCategory } = state[namespace].promo;

			if (currentCategory) return currentCategory;

			const category = selectors.getCategories(state);

			return category && category[0] && category[0]['id'];
		},

		getCategories: state => {
			if (!state[namespace].data || !state[namespace].data.promo) return null;

			const { data: { promo } } = state[namespace];

			const filter = entity => {
				const filtered = Object.keys(promo).filter(
					category => promo[category] && !isEmpty(promo[category])
				);
				return filtered.indexOf(entity.id) > -1;
			};

			return state.app.lists['offer-promo-categories'].filter(filter);
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createPromo;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/promo-gallery/index.js